export default __webpack_public_path__ + "static/iconography-image-e-8460bc5b8524048f767ab15996691d00.png";